import ViewCard from '../../../components/ViewCard/ViewCard'
import './AdministrativeHome.css'
import AdministrativeDashboard from '../AdministrativeDashboard/AdDashboardView/AdministrativeDashboard'
import { ROLE_SECTIONS } from '../../../utils/sidebarURLs'


export default function AdministrativeHome() {
   return (
      <>
         <div className='AdministrativeHome-grid-container'>
            {ROLE_SECTIONS.administracion.items.map(item => {
               if (item.title === 'Dashboard') return
               return < ViewCard key={item.name} item={item} />
            }
            )}
         </div>
         <div>
            < AdministrativeDashboard />
         </div>
      </>
   )
}
